import Icon from '../components/Icon.vue'

Icon.register({
  award: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M97.1 362.6C88.4 353.9 93 356.4 72 350.8 62.5 348.2 54.1 343.3 46.6 337.5L1.2 448.7C-3.2 459.5 5 471.2 16.6 470.7L69.3 468.7 105.6 507C113.6 515.4 127.6 512.8 132 502L184 374.4C173.2 380.5 161.2 384 148.7 384 129.2 384 110.9 376.4 97.1 362.6zM382.8 448.7L337.4 337.5C329.9 343.3 321.5 348.2 312 350.8 290.9 356.4 295.6 354 286.9 362.6 273.1 376.4 254.8 384 235.3 384 222.8 384 210.8 380.4 199.9 374.4L252 502C256.4 512.8 270.4 515.4 278.4 507L314.7 468.7 367.4 470.7C379 471.2 387.2 459.5 382.8 448.7zM263 340C278.3 324.4 280 325.8 301.8 319.9 315.7 316.1 326.5 305 330.3 290.9 337.7 262.5 335.8 265.9 356.2 245.1 366.4 234.8 370.4 219.7 366.6 205.6 359.2 177.2 359.1 181.1 366.6 152.7 370.4 138.6 366.4 123.5 356.2 113.1 335.8 92.4 337.7 95.8 330.3 67.4 326.5 53.3 315.7 42.2 301.8 38.4 273.9 30.8 277.3 32.8 256.8 12 246.7 1.6 231.8-2.4 217.9 1.4 190.1 9 194 9 166.1 1.4 152.2-2.4 137.3 1.6 127.2 12 106.8 32.8 110.1 30.8 82.2 38.4 68.3 42.2 57.5 53.3 53.8 67.4 46.3 95.8 48.2 92.4 27.8 113.1 17.6 123.5 13.7 138.6 17.4 152.7 24.9 181.1 24.9 177.1 17.4 205.5 13.7 219.7 17.6 234.8 27.8 245.1 48.2 265.9 46.3 262.5 53.8 290.9 57.5 305 68.3 316.1 82.2 319.9 104.6 326 106.3 325 121 340 134.2 353.5 154.8 355.9 170.7 345.8A39.7-39.7 0 0 0 213.3 345.8C229.2 355.9 249.8 353.5 263 340zM97.7 176C97.7 122.9 139.9 79.9 192 79.9S286.3 122.9 286.3 176 244.1 272 192 272 97.7 229 97.7 176z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/award.js
// module id = xdvv
// module chunks = 144